import { DocumentTypeCreate } from './DocumentTypeCreate'
import { DocumentTypeEdit } from './DocumentTypeEdit'
import { DocumentTypeList } from './DocumentTypeList'
import { DocumentTypeShow } from './DocumentTypeShow'

export { DocumentTypeCreate, DocumentTypeEdit, DocumentTypeList, DocumentTypeShow }
